import { render, staticRenderFns } from "./ProductDialog.vue?vue&type=template&id=5fb88a92&scoped=true"
import script from "./ProductDialog.vue?vue&type=script&lang=js"
export * from "./ProductDialog.vue?vue&type=script&lang=js"
import style0 from "./ProductDialog.vue?vue&type=style&index=0&id=5fb88a92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb88a92",
  null
  
)

export default component.exports